module.exports = __webpack_public_path__ + "img/Weapon_203.e1b76926.png";